import { directusService, limiter } from './api.service';

export const getConfig = limiter.wrap(
  async (): Promise<{ [key: string]: any }> => {
    const { data } = await directusService.get('/items/config');

    return data;
  },
);

export const getConfigByFields = async <T>(fields: (keyof T)[]) => {
  const { data }: { data: { [K in keyof T]: T[K] } } =
    await directusService.get<{ [K in keyof T]: T[K] }>(`/items/config/`, {
      params: {
        fields: fields.join(','),
      },
    });

  return data;
};
